<template>
	<div :class="['productone',index != 0?'productone--bortop':'']">
		<div class="productone-app">
			<div class="flex productone-ap-one">
				<div class="productone-app_logo"><img :src="item.logo"></div>
				<div class="productone-app_title">{{item.title}}</div>
				<v-touch v-if="isTikTok" class="productone-app_btn" :class="{ 'is-disabled': ![2345].includes(item.channelId) }" @tap="showCode(item)"></v-touch>
			</div>
			<div class="productone-app_tis">{{item.description}}</div>
		</div>
		<div class="productone-app-tests_title">精选多款子产品</div>
		<div class="productone-app-tests">
			<div class="tests-one" v-for="(one,index) in item.promoScaleVoList" :key="index">
				<div class="tests-one_logo">
					<img :src="one.logoUrl">
				</div>
				<div class="tests-one_text">
					<p class="tests-one_text_title">{{one.name}}</p>
					<p class="tests-one_text_tis">{{one.shortDesc}}</p>
				</div>
				<v-touch v-if="isTikTok" class="tests-one_btn" :class="{ 'is-disabled': ![2473,2345].includes(item.channelId) }" @tap="showCode(one)">推广</v-touch>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	components: {

	},
	data() {
			return {

			}
	},
	watch:{
	},
	props: {
		item:{
			type:Object,
			default:function(){
				return {}
			}
		},
		index:{
			type:Number,
			default:0
		}
	},
	computed: {
		...mapGetters(['extendPlatform']),
        isTikTok () {
            return this.extendPlatform === 'tiktok'
        },
	},
	mounted() {
	},
	methods: {
		showCode(obj){
			console.log(obj)
			this.$emit('_showCode',obj)
		}
	}
}
</script>

<style lang="scss">
@import "../../scss/function";
@import "../../scss/config";
.productone--bortop{
  border-top: topx(2rem) solid #ddd;
}
.productone{
  padding: topx(40rem) 0;
  .productone-app{
    background: #fff;
    .productone-app_logo{
      width: topx(120rem);
      height: topx(120rem);
      overflow: hidden;
			background: #fff;
			box-shadow:0 topx(10rem) tox(20rem) topx(-12rem) #FFC500;
			border-radius:topx(12rem);
			flex-shrink: 0;
      img{
        width: 100%;
        height: auto;
      }
    }
    .productone-app_title{
      font-size:topx(32rem);
      color:#4C4B58;
      line-height:topx(38rem);
      margin-left: topx(20rem);
      font-weight: bolder;
      margin-right: topx(200rem);
    }
    .productone-app_btn{
      width: topx(200rem);
      height: topx(68rem);
      background: url('../../assets/toutiao/btn-download.png') no-repeat
        center;
      background-size: topx(200rem) topx(68rem);
      position: absolute;
      top: 0;
      right: 0;

      &.is-disabled {
        pointer-events: none;
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
    }
  }
  .productone-ap-one{
  	position: relative;
  }
  .productone-app_tis{
		font-size:topx(24rem);
		color:#666666;
		line-height:topx(36rem);
		margin-top: topx(30rem);
  }
  .productone-app-tests_title{
		font-size:topx(32rem);
		color:#4C4B58;
		line-height:topx(32rem);
		padding: topx(30rem) 0 topx(10rem) 0;
		border-top: topx(1rem) solid #F0F0F0;
		margin-top: topx(30rem);
		font-weight: bolder;
  }
  .productone-app-tests{
  	.tests-one{
  		display: flex;
  		margin-top: topx(30rem);
  		position: relative;
  		padding-right: topx(120rem);
  		.tests-one_logo{
  			width: topx(80rem);
  			height: topx(80rem);
  			overflow: hidden;
 				background:#FFD6D6;
				border-radius:topx(6rem);
  			img{
  				width: 100%;
  				height: auto;
  			}
  		}
  		.tests-one_text{
				margin-left: topx(20rem);
				width: topx(300rem);
				.tests-one_text_title{
					font-size:topx(28rem);
					line-height:1.43;
					color: #4C4B58;
					@include limitLine(1);
				}
				.tests-one_text_tis{
					font-size:topx(24rem);
					line-height:1.43;
					color: #999999;
					margin-top: topx(15rem);
					@include limitLine(1);
				}
  		}
  		.tests-one_btn{
  			width: topx(200rem);
  			height: topx(68rem);
            font-size:topx(28rem);
            color:#FF546E;
            line-height:topx(32rem);
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: topx(-32rem);
            text-align: right;
            line-height: topx(68rem);

            &.is-disabled {
                color: gray;
                pointer-events: none;
            }
  		}
  	}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toutiao/productOne.vue